"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConditionalUpdateEffect = void 0;
var __1 = require("..");
/**
 * Like `useUpdateEffect` but callback invoked only if conditions match predicate.
 *
 * @param callback Callback to invoke
 * @param conditions Conditions array
 * @param deps Dependencies list like for `useEffect`. If set - effect will be
 * triggered when deps changed AND conditions are satisfying predicate.
 * @param predicate Predicate that defines whether conditions satisfying certain
 * provision. By default, it is all-truthy provision, meaning that all
 * conditions should be truthy.
 */
function useConditionalUpdateEffect(callback, conditions, deps, predicate) {
    if (predicate === void 0) { predicate = __1.truthyAndArrayPredicate; }
    // eslint-disable-next-line consistent-return
    (0, __1.useUpdateEffect)(function () {
        if (predicate(conditions)) {
            return callback();
        }
    }, deps);
}
exports.useConditionalUpdateEffect = useConditionalUpdateEffect;
